<template>
  <div class="flex items-center gap-2">
    <Button
      variant="outline"
      size="sm"
      type="button"
      class="h-8 max-w-52 justify-start truncate"
      :loading="isUpdating"
      @click="openAssigneeModal"
    >
      <span v-if="showLabel" class="text-sm text-muted-foreground">
        {{ taskTemplate.assigned_to_user_id ? 'Default Assignee' : 'Not assigned' }}
      </span>{{ assigneeLabel }}
    </Button>
    <TaskTemplateAssignToUserModal
      ref="assignToUserModal"
      :task-template-id="taskTemplateId"
      :assignee-id="normalizedAssigneeId"
      :context="context"
      @loaded-users="setAssignableUsers"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Button } from '../../../../../../../../resources/js/components/ui/button/index.js'
import { useTaskTemplateStore } from '../../../stores/taskTemplateStore.js'
import TaskTemplateAssignToUserModal from './TaskTemplateAssignToUserModal.vue'

const assignToUserModal = ref(null)
const assignableUsers = ref([])

const props = defineProps({
  taskTemplate: {
    type: Object,
    required: true,
  },
  value: {
    type: [Number, String, Object],
    default: null,
  },
  context: {
    type: String,
    default: 'task-template-show',
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})

const taskTemplateStore = useTaskTemplateStore(props.context)
const taskTemplateId = computed(() => Number(props.taskTemplate?.id))
const normalizedAssigneeId = computed(() => {
  const parsedId = Number(props.value)

  if (!Number.isInteger(parsedId) || parsedId <= 0) {
    return null
  }

  return parsedId
})
const assigneeUser = computed(() => assignableUsers.value.find((user) => user.id === normalizedAssigneeId.value) ?? null)
const cachedAssigneeName = computed(() => {
  const name = props.taskTemplate?.cached?.assigned_to_user?.name

  if (typeof name !== 'string' || name.trim() === '') {
    return null
  }

  return name
})
const assigneeLabel = computed(() => {
  if (assigneeUser.value) {
    return assigneeUser.value.name
  }

  if (cachedAssigneeName.value) {
    return cachedAssigneeName.value
  }

  if (normalizedAssigneeId.value !== null) {
    return `User #${normalizedAssigneeId.value}`
  }

  return 'Unassigned'
})
const isUpdating = computed(() => taskTemplateStore.isUpdatingAssignee(taskTemplateId.value))

const openAssigneeModal = () => {
  assignToUserModal.value?.openModal?.()
}

const setAssignableUsers = (users) => {
  assignableUsers.value = Array.isArray(users) ? users : []
}
</script>
